<form [formGroup]="addStakeholderForm" (ngSubmit)="addStakeholder()">
  Category <span class="text-danger small">(required)</span>
  <div class="form-group col-md-12 mt-2 ps-0">
    <div class="btn-group btn-group-toggle" data-bs-toggle="buttons">
      <label class="btn btn-outline-primary" [ngClass]="{ 'active': addStakeholderForm.get('category').value === 'institutions' }">
        <input type="radio" formControlName="category" (change)="selectCategory('institutions')" [checked]="addStakeholderForm.get('category').value === 'institutions'">
        Institution
      </label>
      <label class="btn btn-outline-primary" [ngClass]="{ 'active': addStakeholderForm.get('category').value === 'media' }">
        <input type="radio" formControlName="category" (change)="selectCategory('media')" [checked]="addStakeholderForm.get('category').value === 'media'">
        Media
      </label>
      <label class="btn btn-outline-primary" [ngClass]="{ 'active': addStakeholderForm.get('category').value === 'corporate' }">
        <input type="radio" formControlName="category" (change)="selectCategory('corporate')" [checked]="addStakeholderForm.get('category').value === 'corporate'">
        Third parties
      </label>
    </div>
  </div>
  <div [hidden]="!addStakeholderForm.get('category').value">
    <div class="row">
      <div class="form-group col-md-6">
        <label>First name <span class="text-danger small">(required)</span></label>
        <input type="text" class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'firstName')"
          (change)="setGender()" (blur)="fieldToSentenceCase('firstName')"
          formControlName="firstName" placeholder="Mario" required>
      </div>
      <div class="form-group col-md-6">
        <label>Last name <span class="text-danger small">(required)</span></label>
        <input type="text" class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'lastName')"
          formControlName="lastName" (blur)="fieldToSentenceCase('lastName')" placeholder="Rossi" required>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label>Gender <span class="text-danger small">(required)</span></label>
        <select class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'gender')"
          formControlName="gender" required>
          <option value="" selected>Select gender</option>
          <option value="male">Man</option>
          <option value="female">Woman</option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <label>Role <span class="text-danger small">(required)</span></label>
        <select class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'job')"
          formControlName="job" required>
          <option value="" selected>No role</option>
          <optgroup label="Institutions">
            @for (role of roles; track role) {
              <option [value]="role">{{role}}</option>
            }
          </optgroup>
          <optgroup label="Media">
            @for (role of rolesMedia; track role) {
              <option [value]="role">{{role}}</option>
            }
          </optgroup>
          <optgroup label="Other">
            @for (role of rolesOther; track role) {
              <option [value]="role">{{role}}</option>
            }
          </optgroup>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label>Email</label>
        <input type="email" class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'email')"
          formControlName="email" placeholder="email@example.com">
      </div>
      <div class="form-group col-md-6">
        <label>Phone</label>
        <input type="text" class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'phone')"
          formControlName="phone" placeholder="3331231231">
      </div>
    </div>
    <div formGroupName="socials" class="row">
      <div formGroupName="twitter" class="form-group col-md-3">
        <label>X</label>
        <input type="text" class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'socials.twitter.username')"
          formControlName="username" (change)="formatUsername('twitter')" placeholder="mario_rossi">
      </div>
      <div formGroupName="instagram" class="form-group col-md-3">
        <label>Instagram</label>
        <input type="text" class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'socials.instagram.username')"
          formControlName="username" (change)="formatUsername('instagram')" placeholder="mario.rossi">
      </div>
      <div formGroupName="facebook" class="form-group col-md-3">
        <label>Facebook</label>
        <input type="text" class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'socials.facebook.username')"
          formControlName="username" (change)="formatUsername('facebook')" placeholder="MarioRossiOfficial">
      </div>
      <div formGroupName="linkedin" class="form-group col-md-3">
        <label>LinkedIn</label>
        <input type="text" class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'socials.linkedin.username')"
          formControlName="username" (change)="formatUsername('linkedin')" placeholder="mario-rossi">
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <label>Notes</label>
        <textarea class="form-control" rows="5" [ngClass]="setClassInvalid(addStakeholderForm, 'notes')"
        formControlName="notes" placeholder="Notes"></textarea>
      </div>
    </div>
    @if (addStakeholderForm.get('category').value === 'media') {
      <div class="row">
        <div class="form-group col-md-6">
          <label>Media company <a class="ms-2 small" [routerLink]="" (click)="changeContent('add-new-media')"><i class="fa fa-plus-circle"></i> Add new</a></label>
          <select class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, '_media')" formControlName="_media">
            <option value="" selected>No media company</option>
            @for (media of medias; track media) {
              <option [value]="media._id">{{media.name}}</option>
            }
          </select>
        </div>
      </div>
    }
    @if (addStakeholderForm.get('category').value === 'institutions') {
      <div class="row">
        <div class="form-group col-md-3">
          <label>Organ</label>
          <select class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'organ')" formControlName="organ">
            <option value="" selected>No organ</option>
            @for (organ of organs; track organ) {
              <option [value]="organ">{{organ}}</option>
            }
          </select>
        </div>
        <div class="form-group col-md-3">
          <label>Ministry</label>
          <select class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'office')" formControlName="office">
            <option value="" selected>No ministry</option>
            <optgroup label="Ministry">
              @for (office of offices; track office) {
                <option [value]="office">{{office}}</option>
              }
            </optgroup>
            <optgroup label="Ministry no portfolio">
              @for (office of officesNoPortfolio; track office) {
                <option [value]="office">{{office}}</option>
              }
            </optgroup>
            <optgroup label="Other">
              @for (office of officesOther; track office) {
                <option [value]="office">{{office}}</option>
              }
            </optgroup>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label class="me-1">Governments:</label>
          <input type="hidden" class="form-control" formControlName="_governments">
          <app-search-input model="government" placeholder="Meloni"></app-search-input>
        </div>
        <div class="form-group col-md-3">
          <label class="me-1">Legislatures:</label>
          <input type="hidden" class="form-control" formControlName="_legislatures">
          <app-search-input model="legislature" placeholder="XIX"></app-search-input>
        </div>
      </div>
    }
    @if (addStakeholderForm.get('category').value === 'institutions') {
      <div class="row">
        <div class="form-group col-md-4">
          <label>Party</label>
          <select class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, '_party')" formControlName="_party">
            <option value="" selected>No party</option>
            <optgroup label="Italy">
              @for (party of parties; track party) {
                <option [value]="party._id">{{party.name}}</option>
              }
            </optgroup>
            <optgroup label="EU">
              @for (party of partiesEU; track party) {
                <option [value]="party._id">{{party.name}}</option>
              }
            </optgroup>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label>Commission</label>
          <select class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, '_commissions')" formControlName="_commissions">
            <option value="" selected>No commission</option>
            <optgroup label="Camera">
              @for (commission of commissionsCamera; track commission) {
                <option [value]="commission._id">
                  {{commission.name}} ({{commission.roman}})
                </option>
              }
            </optgroup>
            <optgroup label="Senato">
              @for (commission of commissionsSenato; track commission) {
                <option [value]="commission._id">
                  {{commission.name}} ({{commission.roman}})
                </option>
              }
            </optgroup>
            <optgroup label="European Parliament">
              @for (commission of commissionsEU; track commission) {
                <option [value]="commission._id">
                  {{commission.name}} ({{commission.roman}})
                </option>
              }
            </optgroup>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label>College region</label>
          <select class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'college')" formControlName="college">
            <option value="" selected>No college region</option>
            @for (college of collegeRegions; track college) {
              <option [value]="college">{{college}}</option>
            }
          </select>
        </div>
      </div>
    }
    <div class="row">
      <div class="form-group col-md-4">
        <label>Speak English</label>
        <select class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'english')" formControlName="english">
          <option value="" disabled>Select speaking</option>
          <option [value]="true">Yes</option>
          <option [value]="false" selected>No</option>
        </select>
      </div>
      <div class="form-group col-md-4">
        <label>Birthday</label>
        <input type="date" class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'birthday')"
          formControlName="birthday" [max]="today" [pattern]="dateRegexp" placeholder="YYYY-MM-DD">
      </div>
      <div class="form-group col-md-4">
        <label>Birthplace</label>
        <input type="text" class="form-control" [ngClass]="setClassInvalid(addStakeholderForm, 'birthplace')"
          formControlName="birthplace" placeholder="Roma">
      </div>
    </div>
    <div class="d-flex flex-column">
      <label>Topics</label>
      <div class="mb-3">
        @for (cluster of clusters; track cluster) {
          <div class="btn btn-sm m-1" [ngClass]="{ 'btn-primary': politicianTopics?.includes(cluster), 'btn-outline-primary': !politicianTopics?.includes(cluster) }"
            (click)="selectCluster(cluster)">
            {{cluster}} @if (politicianTopics?.includes(cluster)) {
            <i class="fa fa-check-square-o"></i>
          }
        </div>
      }
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12">
      <button class="btn btn-primary d-block" type="submit" [disabled]="!addStakeholderForm.valid">
        <i class="fa fa-user-plus"></i> Add stakeholder
      </button>
    </div>
  </div>
</div>
</form>